import { requests } from '@ott/shared-credit-cards-logic';

type Params = {
  cardNumber: string;
  excludeCardCountryCodes: Array<{
    code: string;
    message: string;
  }>;
};

const BIN_LENGTH = 6;
const BIN_COUNTRY_CACHE: Record<string, string> = {};

export const validateByCountryCode = async ({ cardNumber, excludeCardCountryCodes }: Params) => {
  const bin = cardNumber.replace(/\s/g, '').slice(0, BIN_LENGTH);

  if (bin.length >= BIN_LENGTH) {
    let countryCode;

    if (BIN_COUNTRY_CACHE[bin]) {
      countryCode = BIN_COUNTRY_CACHE[bin];
    } else {
      const { countryCode: responseCountryCode } = await requests.getCardInfoByBIN({ bin });
      countryCode = responseCountryCode;
      BIN_COUNTRY_CACHE[bin] = responseCountryCode;
    }

    const excludeRule = excludeCardCountryCodes.find(
      ({ code }) => code.toUpperCase() === countryCode
    );
    if (excludeRule) {
      return excludeRule.message;
    }
  }

  return null;
};
